






























import AdminNavbar from '@/components/AdminNavbar.vue'
import UserModal from '@/components/UserModal.vue'

export default {
  name: 'AdminUsers',
  components: {
    AdminNavbar,
    UserModal,
  },
  data () {
    return {
      userList: [],
      assessments: []
    }
  },
  methods: {

    showBankDetails (bank: Bank) {
      this.$router.push('/admin/banks/'+bank.id)
    },

    async loadUsers () {
      const result = await this.$store.dispatch('getAdminUsers')
      if (result.success) {
        this.userList = result.data
      }
    },

    newUser () {
      this.$refs.userModal.show({role: 'admin'})
    },

    editUser (user: User) {
      this.$refs.userModal.loadAndShow(user)
    },

    newQuestionnaire () {

    },

  },
  mounted () {
      this.loadUsers()
  }
}
